"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Copyright 2019 Amplify Inc. All Rights Reserved.

/**
 * @fileoverview A base class that defines a common interface for event trackers.
 * @author jgraham@amplify.com (Jessica Graham)
 */
var EventTracker = /*#__PURE__*/function () {
  /**
   * @param {EventService} eventService
   * @param {Object} trackingConfig
   */
  function EventTracker(eventService, trackingConfig) {
    _classCallCheck(this, EventTracker);

    this.eventService = eventService;
    this.trackingConfig = trackingConfig; // Migrate page open to view

    if (typeof trackingConfig !== 'undefined' && typeof trackingConfig.trackPageOpen !== 'undefined' && typeof trackingConfig.trackPageView == 'undefined') {
      trackingConfig.trackPageView = trackingConfig.trackPageOpen;
    }

    this.contextExtensions = {};
    this.resultExtensions = {};
  }
  /**
   * Stub method for starting event tracking. Should be implemented by child classes.
   */


  _createClass(EventTracker, [{
    key: "start",
    value: function start() {
      console.warn("".concat(this.constructor.name, " should implement the start function"));
    }
    /**
     * Stub method for stopping event tracking. Should be implemented by child classes.
     */

  }, {
    key: "stop",
    value: function stop() {
      console.warn("".concat(this.constructor.name, " should implement the stop function"));
    }
    /**
     * Add context extensions
     *
     * @param {Object} extensions Object of extensions to add.
     * **/

  }, {
    key: "addContextExtensions",
    value: function addContextExtensions(extensions) {
      Object.assign(this.contextExtensions, extensions);
    }
    /**
     * Add result extensions
     *
     * @param {Object} extensions Object of extensions to add.
     * **/

  }, {
    key: "addResultExtensions",
    value: function addResultExtensions(extensions) {
      Object.assign(this.resultExtensions, extensions);
    }
  }]);

  return EventTracker;
}();

var _default = EventTracker;
exports["default"] = _default;
module.exports = exports.default;